/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Start_Five_BodyInputs */

const en_us2_clubs_start_five_body = /** @type {(inputs: Clubs_Start_Five_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With five people, someone is almost always training on the same day as you.`)
};

const pt_br2_clubs_start_five_body = /** @type {(inputs: Clubs_Start_Five_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com cinco pessoas, quase sempre tem alguém treinando no mesmo dia que você.`)
};

const es_419_clubs_start_five_body = /** @type {(inputs: Clubs_Start_Five_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con cinco personas, casi siempre alguien entrena el mismo día que tú.`)
};

const pt_pt2_clubs_start_five_body = /** @type {(inputs: Clubs_Start_Five_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com cinco pessoas, quase sempre há alguém a treinar no mesmo dia que tu.`)
};

const fr_fr2_clubs_start_five_body = /** @type {(inputs: Clubs_Start_Five_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À cinq, il y a presque toujours quelqu'un qui s'entraîne le même jour que toi.`)
};

const de_de2_clubs_start_five_body = /** @type {(inputs: Clubs_Start_Five_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit fünf Leuten trainiert fast immer jemand am selben Tag wie du.`)
};

const it_it2_clubs_start_five_body = /** @type {(inputs: Clubs_Start_Five_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In cinque, quasi sempre qualcuno si allena nel tuo stesso giorno.`)
};

/**
* | output |
* | --- |
* | "With five people, someone is almost always training on the same day as you." |
*
* @param {Clubs_Start_Five_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_start_five_body = /** @type {((inputs?: Clubs_Start_Five_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Start_Five_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_start_five_body(inputs)
	if (locale === "es-419") return es_419_clubs_start_five_body(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_start_five_body(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_start_five_body(inputs)
	if (locale === "de-DE") return de_de2_clubs_start_five_body(inputs)
	if (locale === "it-IT") return it_it2_clubs_start_five_body(inputs)
	return en_us2_clubs_start_five_body(inputs)
});
export { clubs_start_five_body as "clubs.start_five_body" }